import axios from 'axios';

async function listEmployeesByHierarchyId(hierarchyId) {
  if (hierarchyId == null) return [];

  const url = `Employee/listEmployeesByHierarchyId/${hierarchyId}`;
  const request = {
    method: 'GET',
    url: url,
  };

  const res = await axios(request);
  return res.data;
}

async function addEmployee(employeeData) {
  const url = `Employee/`;
  const request = {
    method: 'POST',
    url: url,
    data: employeeData,
  };

  const res = await axios(request);
  return res.data;
}

async function getEmployeeDetails(employeeId) {
  const url = `Employee/${employeeId}`;
  const request = {
    method: 'GET',
    url: url,
  };

  const res = await axios(request);
  return res.data;
}




const EmployeeService = {
  listEmployeesByHierarchyId,
  addEmployee,
  getEmployeeDetails,
};

export default EmployeeService;